import { render, staticRenderFns } from "./giftAmountPop.vue?vue&type=template&id=1ac45e19&scoped=true"
import script from "./giftAmountPop.vue?vue&type=script&lang=js"
export * from "./giftAmountPop.vue?vue&type=script&lang=js"
import style0 from "./giftAmountPop.vue?vue&type=style&index=0&id=1ac45e19&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac45e19",
  null
  
)

export default component.exports